import React from 'react'
import { cn } from '@/utilities/ui'
import { CLIENT_AUTH_PAGE_SHELL_CLASS, getAuthSpinnerClass } from '@/utilities/authLayoutStyles'

interface ClientAuthLoadingFallbackProps {
  title?: string
  description?: string
}

export function ClientAuthLoadingFallback({
  title = 'Loading...',
  description,
}: Readonly<ClientAuthLoadingFallbackProps>) {
  return (
    <div className={cn(CLIENT_AUTH_PAGE_SHELL_CLASS, 'bg-special-grey')}>
      <div className="max-w-md w-full space-y-8 text-center">
        <div className={`${getAuthSpinnerClass(true)} mx-auto`} />
        <h1 className="text-2xl font-medium text-dark-blue">{title}</h1>
        {description ? <p className="text-placeholder">{description}</p> : null}
      </div>
    </div>
  )
}
